import {
  Alert,
  Chip,
  CircularProgress,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import { useMyRequests } from '../api/queries';
import { shortDate } from '../lib/format';

const STATUS_COLOR: Record<string, 'default' | 'info' | 'success' | 'error'> = {
  drafted: 'default',
  submitted: 'info',
  fulfilled: 'success',
  denied: 'error',
};

export default function MyRequests() {
  const { data, isLoading, error } = useMyRequests();

  if (isLoading) return <CircularProgress />;
  if (error) return <Alert severity="error">Failed to load requests: {String(error)}</Alert>;

  return (
    <Stack spacing={3}>
      <div>
        <Typography variant="h4" component="h1" gutterBottom>
          My Requests
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {data?.length ?? 0} access requests
        </Typography>
      </div>

      {data && data.length > 0 ? (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Request ID</TableCell>
              <TableCell>App</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Manager CC&apos;d</TableCell>
              <TableCell>Requested</TableCell>
              <TableCell>Fulfilled</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((r) => (
              <TableRow key={r.id}>
                <TableCell title={r.id} className="font-mono">
                  {r.id.slice(0, 8)}
                </TableCell>
                <TableCell>{r.app_name}</TableCell>
                <TableCell>
                  <Chip size="small" label={r.status} color={STATUS_COLOR[r.status] ?? 'default'} />
                </TableCell>
                <TableCell>{r.manager_email ?? '—'}</TableCell>
                <TableCell>{shortDate(r.created_at)}</TableCell>
                <TableCell>{shortDate(r.fulfilled_at)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        <Typography color="text.secondary">
          No requests yet — find an app in Browse and hit “Request access”.
        </Typography>
      )}
    </Stack>
  );
}
